// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1RCKJ","modalForm":"UpgradeEpcsModal_modalForm__1yact","modalFooter":"UpgradeEpcsModal_modalFooter__38hVW"};